import AppSidebar from '@/components/feature/AppSidebar';
import AvisoEmailNaoVerificado from '@/components/feature/AvisoEmailNaoVerificado';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="min-h-screen flex bg-background-50">
      <AppSidebar />
      <main className="flex-1 min-w-0 overflow-y-auto">
        <div className="px-6 md:px-8 py-6 md:py-8">
          {/* Fica no layout, e não em cada tela: a pendência acompanha a conta,
              não a página. Ele mesmo se esconde quando não há o que avisar. */}
          <AvisoEmailNaoVerificado />
          {children}
        </div>
      </main>
    </div>
  );
}
